import styled from 'styled-components';
import { device } from '../media_queries';

const MainDocInput = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 2px 10px 0 rgba(0, 34, 91, 0.11);
  border: solid 1px #dfe8ee;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    width: 20%;
    height: auto;
    margin: 10px;
    padding: 5px;
  }
  @media ${device.desktop} {
    
  }
`;

const LabelDocInput = styled.label`
  text-align: center;
  width: 100%;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    font-size: 1em;
  }
  @media ${device.desktop} {
    
  }
`;

const DocInput = styled.input`
  /* text-align: center; */
  width: 100%;
  margin: 3px 0;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    /* font-size: 2em; */
  }
  @media ${device.desktop} {
    
  }
`;

export { MainDocInput, LabelDocInput, DocInput };